import getRoleProperty from '../getRoleProperty';

class ContactRoleNamedInsured {
    constructor() {
        this.$onInit = () => {
            const {fieldValueGetter} = getRoleProperty(this.roleType, this.roleModel, 'namedInsured', 'policyAdditionalNamedInsured');
            this.busOpDescription = fieldValueGetter('busOpDescription');
            this.orgType = fieldValueGetter('organizationType');
            if (this.contactType !== 'Person') {
                this.industryCode = fieldValueGetter('industryCode');
                this.industryCodeClassification = fieldValueGetter('industryCodeClassification');
            }
        };
    }
}

export default ContactRoleNamedInsured;
